import axios from 'axios';

async function ObtenerSocio(prm_idSocio: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_socio"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_socio": prm_idSocio
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerSocio;